import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../Helpers/API";
import {
  Autocomplete,
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";


const EditarCategoriaModal = ({ open, onClose, id }) => {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [categoria, setCategoria] = useState({
    id: 0,
    descripcion: ""
  });

  useEffect(() => {
    if (id) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`CategoriasModelos/GetCategoriaID?id=${id}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setCategoria(result[0]);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          return;
        });
      setLoader({ ...loader, mostrar: false });
    }
  }, [id]);
  console.log(id)

  const editarCategoria = () => {
    if (
      categoria.descripcion === "" ||
      categoria.descripcion === null ||
      categoria.descripcion === undefined
    ) {
      Swal.fire({
        title: "CATEGORIAS",
        text: "Debe escribir una descripción para la categoria",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    const post = {
      id_categoria: id,
      descripcion: categoria.descripcion,
      estatus: 1,
      usuario: 0
    };

    setLoader({ ...loader, mostrar: true });
    request
      .post(`CategoriasModelos/EditarCategoria`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        onClose();
        setCategoria({
          ...categoria,
          id: 0,
          descripcion: "",
        })
        await Swal.fire({
          title: "CATEGORIAS",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CATEGORIAS", JSON.stringify(error), "error");
      });
  };

  const onCerrar = () => {
    setCategoria({
      ...categoria,
      id: 0,
      descripcion: "",
    })
    onClose()
  }
  return (
    <>
      <Modal open={open} onClose={onCerrar}>
        <div className="categorias-modelos-modal-formulario">
          <div className="categorias-modelos-modal-plantilla">
            <div
              className="plantilla-screen-filtro-container"
              id="mdlFiltros-modal"
            >
              <PlantillaScreen
                titulo={"EDITAR CATEGORIA"}
                className_main={1}
                className={"plantilla-screen-filtro-container-modal"}
              >
                <div className="cerrar-modal-button" onClick={onCerrar}>
                  X
                </div>
                <div className={`categorias-modelos-modal-agregar-convenio`}>
                  <div className="categorias-modelos-modal-agregar-convenio-container scroll-4">
                    <TextField
                      id="outlined-multiline-static"
                      label="Categoria"
                      sx={{ mt: 2 }}
                      size="small"
                      value={categoria.descripcion}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^[a-zA-Z0-9ñÑ., ]*$/;

                        if (regex.test(value)) {
                          setCategoria({
                            ...categoria,
                            descripcion: e.target.value,
                          });
                        }
                      }}
                    />
                  </div>
                  <div className="categorias-modelos-modal-buttons">
                    <button
                      className="categorias-modelos-modal-button-guardar"
                      onClick={() => editarCategoria()}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </PlantillaScreen>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditarCategoriaModal;
